import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import InlineBanner from '@/components/inline-banner'
import { alertOneTime, alertPadActive, alertPadDisabled, alertPadRequested } from './alerts'

const Alert = ({ isPadActive, isPadRequested, isPadEnabled }) => {
  const { t } = useTranslation()
  const { values } = useFormikContext()

  if (values.request_type === 'one_time') return <InlineBanner space="fit" {...alertOneTime(t)} />
  else if (values.request_type === 'pad') {
    if (isPadActive) return <InlineBanner space="fit" {...alertPadActive(t)} />
    else if (isPadRequested) return <InlineBanner space="fit" {...alertPadRequested(t)} />
    else if (!isPadEnabled) return <InlineBanner space="fit" {...alertPadDisabled(t)} />
  }
  return <InlineBanner space="fit" isShow={false} />
}

export default Alert
